import { Action } from '@ngrx/store';

// Constants
export const PROJECT_VIEW = '[Core - UI] Project Dashboard View';
export const COLLAPSE_SIDEBAR = '[Core - UI] Collapse Sidebar';
export const START_OR_STOP_SEARCH = '[Core - UI] Start Or Stop Search';
// Constants - Autosave
export const AUTO_SAVED = '[Core - Autosave] Auto saved';
export const AUTO_SAVING = '[Core - Autosave] Auto saving';
export const CLEAR_AUTO_SAVE = '[Core - Autosave] Clear';
// Constants - App Language
export const LANGUAGE_CHANGE = '[Core - Language] Language Change';
// Constants - Project Section Selected
export const PROJECT_SECTION_SELECTED = '[Core - Project] Section Selected';
export const PROJECT_COLOR = '[ Core - Project ] Color selected';

// Actions
export class ProjectView implements Action {
  readonly type = PROJECT_VIEW;
}
export class StartSearch implements Action {
  readonly type = START_OR_STOP_SEARCH;
}
export class CollapseSidebar implements Action {
  readonly type = COLLAPSE_SIDEBAR;
}
// Actions - Autosave
export class AutoSaved implements Action {
  readonly type = AUTO_SAVED;
}
export class AutoSaving implements Action {
  readonly type = AUTO_SAVING;
}
export class ClearAutosave implements Action {
  readonly type = CLEAR_AUTO_SAVE;
}
// Actions - App Language
export class LanguageChange implements Action {
  readonly type = LANGUAGE_CHANGE;
  constructor(public payload: string) {}
}
// Actions - Project Section Selected
export class SelectProjectSection implements Action {
  readonly type = PROJECT_SECTION_SELECTED;
  constructor(public payload: string) {}
}
export class SelectProjectColor implements Action {
  readonly type = PROJECT_COLOR;
  constructor(public payload: string) {}
}

// Export Actions
export type Actions =
  | AutoSaved
  | AutoSaving
  | ProjectView
  | StartSearch
  | ClearAutosave
  | LanguageChange
  | CollapseSidebar
  | SelectProjectSection
  | SelectProjectColor;



// WEBPACK FOOTER //
// ./src/app/core/actions/ui.actions.ts